(() => {
  'use strict';
  const dialog = document.getElementById('toju-sandberg-upsell');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const root = (window.Shopify?.routes?.root || window.routes?.rootUrl || '/').replace(/\/?$/, '/');
  const productId = Number(dialog.dataset.productId);
  const add = dialog.querySelector('[data-paste-add]');
  const error = dialog.querySelector('[data-paste-error]');
  const sessionKey = 'toju-sandberg-paste-offered-v1';
  let checking = false, busy = false, offered = false, variant;
  try { offered = sessionStorage.getItem(sessionKey) === '1'; } catch (_) { /* Storage is optional. */ }

  async function json(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, { ...options, credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Request failed');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  const cart = () => json(root + 'cart.js', { cache: 'no-store' });
  const hasPaste = data => data.items.some(item => Number(item.product_id) === productId);
  function eligible(item) {
    return item && String(item.vendor).trim().toLowerCase() === 'sandberg'
      && /^(tapeten?|wallpapers?)$/i.test(String(item.product_type).trim())
      && Number(item.product_id) !== productId
      && !/muster|sample|swatch/i.test((item.product_title || '') + ' ' + (item.variant_title || ''));
  }
  const toggle = () => document.querySelector('[data-action="toggle-mini-cart"]');
  const drawerOpen = () => document.getElementById('mini-cart')?.getAttribute('aria-hidden') === 'false';
  function waitForDrawer() {
    if (drawerOpen()) return Promise.resolve(true);
    return new Promise(resolve => {
      const observer = new MutationObserver(() => { if (drawerOpen()) finish(true); });
      const timeout = setTimeout(() => finish(false), 4000);
      function finish(open) { clearTimeout(timeout); observer.disconnect(); resolve(open); }
      observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-hidden'] });
    });
  }
  function finish(reopen = true) {
    dialog.close();
    if (reopen && !drawerOpen()) toggle()?.click();
  }
  dialog.querySelectorAll('[data-paste-dismiss]').forEach(button => button.addEventListener('click', () => { if (!busy) finish(); }));
  dialog.addEventListener('cancel', event => { event.preventDefault(); if (!busy) finish(); });

  document.addEventListener('product:added', async event => {
    if (event.detail?.productAdded !== true || checking || offered || window.theme?.cartType !== 'drawer') return;
    const form = event.detail.button?.closest('form') || event.target.closest?.('form');
    const addedId = Number(form?.querySelector('[name="id"]')?.value || event.detail.variant?.id);
    if (!addedId) return;
    checking = true;
    try {
      const contents = await cart();
      const addedItem = contents.items.find(item => Number(item.variant_id) === addedId);
      if (!eligible(addedItem) || hasPaste(contents)) return;
      const product = await json(root + 'products/' + encodeURIComponent(dialog.dataset.productHandle) + '.js', { cache: 'no-store' });
      variant = product.variants.find(item => item.available);
      if (Number(product.id) !== productId || !product.available || !variant) return;
      const price = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency: contents.currency || window.Shopify?.currency?.active || 'EUR'
      }).format(variant.price / 100);
      dialog.querySelector('[data-paste-price]').textContent = price;
      dialog.querySelector('[data-paste-title]').textContent = product.title;
      dialog.querySelector('[data-paste-link]').href = root + 'products/' + encodeURIComponent(product.handle);
      const image = dialog.querySelector('[data-paste-image]');
      if (product.featured_image) { image.src = product.featured_image; image.hidden = false; }
      if (!await waitForDrawer()) return;
      // Close the theme drawer through its own control, then use the native modal's focus handling.
      toggle()?.click();
      if (drawerOpen()) return;
      dialog.showModal();
      offered = true;
      try { sessionStorage.setItem(sessionKey, '1'); } catch (_) { /* Storage is optional. */ }
      add.focus();
    } catch (_) { /* A recommendation must never interrupt the wallpaper purchase. */ }
    finally { checking = false; }
  });

  add.addEventListener('click', async () => {
    if (busy || !variant) return;
    busy = true;
    add.disabled = true;
    error.hidden = true;
    dialog.setAttribute('aria-busy', 'true');
    try {
      if (hasPaste(await cart())) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        finish();
        return;
      }
      await json(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });
      finish(false);
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true, detail: { quantity: 1, productAdded: true, variant: null }
      }));
    } catch (_) {
      error.textContent = 'Der Kleister konnte gerade nicht hinzugefügt werden. Bitte prüfe deinen Warenkorb, bevor du es erneut versuchst.';
      error.hidden = false;
    } finally {
      busy = false;
      add.disabled = false;
      dialog.removeAttribute('aria-busy');
    }
  });
})();
